import Alpine from 'alpinejs';

Alpine.data('header', () => ({
    init() {
        // The header is cached once for the whole site, therefore we set the active state via JS
        let activeLink = this.$root.querySelector(
            'a[href="' + location.pathname + '"], a[href="' + location.origin + '/' + location.pathname + '"]'
        );
        let activeLi = activeLink?.closest('li');
        while (activeLi) {
            activeLi.classList.add('header-menu-item-is-active');
            activeLi = activeLi.parentElement.closest('li');
        }

        window.addEventListener('scroll', () => {
            this.isScrolled = window.scrollY > 10;
        });
    },
    mobileMenuIsOpen: false,
    isScrolled: window.scrollY > 10,
}));
